import React from 'react';
import styles from './ReportRequestsCard.module.scss';
import { Icon } from 'antd';
import { ReactComponent as JKIcon } from '../../../../resource/statistics/ukDropdown.svg'

export const ReportRequestsCard = ({ title, count }) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className={styles.anticon}>
          <Icon
            className={styles.icon}
            component={JKIcon}
          />
        </span>
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.main}>{count}</div>
    </div>
  );
};
